import Vue from 'vue';

export const postDirective = () => {
  Vue.directive('post', {
    bind: function (el: any, binding: any, vnode: any) {
      if (el.nodeName !== 'BUTTON') return

      function clickHandler() {
        el.disabled = true
        const icon = document.createElement('i')
        icon.className = 'el-icon-loading';
        el.classList.add('is-loading')
        el.insertBefore(icon, el.firstChild)

        function closeLoading() {
          el.removeChild(icon)
          el.classList.remove('is-loading')
          el.disabled = false
        }

        if (typeof binding.value !== 'function') {
          setTimeout(() => {
            closeLoading()
          }, binding.value || 1000)
        } else {
          try {
            // v-post 值为函数值时，返回值应是一个promise
            binding.value().finally(() => {
              closeLoading()
            })
          } catch (e) {
            closeLoading()
          }
        }
      }

      el.addEventListener('click', clickHandler)
    }
  })
}
